import { Input, Popover } from '@finbeat/react-toolkit';
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import { postponeOrder } from 'axios/orderApi';
import useApi from 'hooks/useApi';
import { OrderStatusChangeShort } from 'models/api/order';
import { RefObject, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ButtonProps } from 'reactstrap';

type OrderPostponePopoverProps = {
    orderId: string;
    withIcon?: boolean;
    popoverBtn?: boolean;
    buttonProps?: ButtonProps;
    popoverContainer?: string | HTMLElement | RefObject<HTMLElement>;
    currentStatus: string;
};

const OrderPostponePopover = ({
    orderId,
    withIcon = true,
    popoverBtn,
    buttonProps,
    popoverContainer,
    currentStatus,
}: OrderPostponePopoverProps) => {
    const [days, setDays] = useState<number>(0);
    const [hours, setHours] = useState<number>(0);
    const [minutes, setMinutes] = useState<number>(15);
    const [comment, setComment] = useState<string>('');
    const api = useApi();
    const { t } = useTranslation();

    const mutationFunction = () => {
        const newStatus: OrderStatusChangeShort = {
            orderId: orderId,
            status: 'postpone',
            dsc: comment,
            reason: '',
            timeout: days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60,
            currentStatus: currentStatus,
        };
        return postponeOrder(api, newStatus);
    };

    return (
        <Popover
            label={'postpone'}
            textStyle={'danger'}
            buttonIcon={withIcon ? faHourglassHalf : undefined}
            buttonLabel={'BackOfficePostponeOrder'}
            orderId={orderId}
            mutationFunction={mutationFunction}
            popoverBtn={popoverBtn}
            buttonProps={buttonProps}
            popoverContainer={popoverContainer}
            canSave={true}
            refetchQueryKeys={[['order'], 'orderStatusCount']}
            header={
                <>
                    <Trans i18nKey={'BackOfficePostponeOrder'} /> #{orderId}
                </>
            }
        >
            <Input
                id="info-days-field"
                value={days}
                name="days"
                type="text"
                onChange={(e) => setDays(parseInt(e.target.value))}
                label={t('BackOfficeDays')}
            />
            <Input
                id="info-hours-field"
                value={hours}
                name="hours"
                type="text"
                onChange={(e) => setHours(parseInt(e.target.value))}
                label={t('BackOfficeHours')}
            />
            <Input
                id="info-minutes-field"
                value={minutes}
                name="minutes"
                type="text"
                onChange={(e) => setMinutes(parseInt(e.target.value))}
                label={t('BackOfficeMinutes')}
            />

            <Input
                id="info-comment-field"
                value={comment}
                name="comment"
                type="textarea"
                onChange={(e) => setComment(e.target.value)}
                label={t('BackOfficeComment')}
            />
        </Popover>
    );
};

export default OrderPostponePopover;
